import { NgModule } from '@angular/core';
import { NbMenuModule, NbCardModule, NbSelectModule, NbButtonModule, NbIconModule } from '@nebular/theme';

import { ThemeModule } from '../@theme/theme.module';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { KontoModule } from './konto/konto.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HomeDgComponent } from './home-dg/home-dg.component';
import { PodatkiTabelaComponent } from './home-dg/podatki-tabela/podatki-tabela.component';
import { ZusTabelaComponent } from './home-dg/zus-tabela/zus-tabela.component';
import { HomeKhComponent } from './home-kh/home-kh.component';
import { PodatkiTabelaKhComponent } from './home-kh/podatki-tabela/podatki-tabela.component';
import { ZusTabelaKhComponent } from './home-kh/zus-tabela/zus-tabela.component';

@NgModule({
  imports: [
    FormsModule,
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    NbCardModule,
    NbSelectModule,
    NbButtonModule,
    NbIconModule,
    KontoModule,
    TranslateModule,
    NgxDatatableModule.forRoot({
      messages: {
        emptyMessage: 'Brak danych', // Message to show when array is presented, but contains no values
        totalMessage: 'razem', // Footer total message
        selectedMessage: 'zaznaczone', // Footer selected message
      },
    }),
  ],
  declarations: [
    PagesComponent,
    HomeDgComponent,
    PodatkiTabelaComponent,
    ZusTabelaComponent,
    HomeKhComponent,
    PodatkiTabelaKhComponent,
    ZusTabelaKhComponent,
  ],
})
export class PagesModule {
}
